const Health = ({ health }) => {
  return <pre>{health}</pre>;
};

Health.noLayout = true;

export async function getServerSideProps() {
  return {
    props: {
      health: 'ok',
    },
  };
}
export default Health;
